import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c0c510d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "canvas",
  class: "nge-growing-neuron",
  "aria-hidden": "true"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("canvas", _hoisted_1, null, 512 /* NEED_PATCH */))
}